import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useState,
} from "react";

export enum LockedModalClickFrom {
  email = "email",
  nav_bar = "nav_bar",
}

interface GamificationContextInterface {
  openLockedModal: LockedModalClickFrom | null;
  setOpenLockedModal: Dispatch<SetStateAction<LockedModalClickFrom | null>>;
  pitchCount: number | null;
  setPitchCount: Dispatch<SetStateAction<number | null>>;
}

const defaultContextMissingFunction = () => {
  throw new Error("context is missing");
};

const defaultInterface = {
  openLockedModal: null,
  setOpenLockedModal: defaultContextMissingFunction,
  pitchCount: null,
  setPitchCount: defaultContextMissingFunction,
};

const GamificationContext =
  createContext<GamificationContextInterface>(defaultInterface);

interface GamificationProviderProps {
  children: React.ReactNode;
}

const GamificationProvider = ({ children }: GamificationProviderProps) => {
  const [openLockedModal, setOpenLockedModal] =
    useState<LockedModalClickFrom | null>(null);
  const [pitchCount, setPitchCount] = useState<number | null>(null);

  return (
    <GamificationContext.Provider
      value={{
        openLockedModal,
        setOpenLockedModal,
        pitchCount,
        setPitchCount,
      }}
    >
      {children}
    </GamificationContext.Provider>
  );
};

export { GamificationProvider, GamificationContext };
